// tooltipPlugin.js
import Vue from 'vue';
import Tooltip from '../components/common/ToolTip.vue';

const TooltipPlugin = {
  install(Vue) {
    Vue.directive('tooltip', {
      inserted(el, binding) {
        const container = document.createElement('div');
        el.parentNode.insertBefore(container, el);
        container.appendChild(el);

        const tooltipComponent = new Vue({
          render: h =>
            h(Tooltip, {
              props: {
                ...binding.value,
              },
            }),
        }).$mount();

        container.appendChild(tooltipComponent.$el);
        el.tooltipComponent = tooltipComponent;
      },
      unbind(el) {
        const tooltipComponent = el.tooltipComponent;
        if (tooltipComponent) {
          tooltipComponent.$destroy();
        }
        el.tooltipComponent = null;
      },
    });
  },
};

export default TooltipPlugin;
